import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './extensions/login/login.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AccessTokenInterceptorService } from './modules/shared/interceptors/access-token-interceptor.service';
import { ErrorHandleInterceptorService } from './modules/shared/interceptors/error-handle-interceptor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { SharedModule } from './modules/shared/shared.module';
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FirebaseDatabaseService } from './modules/shared/services/firebase-database/firebase-database.service';
import { ResetPasswordComponent } from './extensions/reset-password/reset-password.component';
import { AwsRedirectionComponent } from './extensions/aws-redirection/aws-redirection.component';
import { AwsRedirectionFailedComponent } from './extensions/aws-redirection-failed/aws-redirection-failed.component';
import { create } from 'd3-selection';
import { SignUpComponent } from './extensions/sign-up/sign-up.component';
import { PrivacyAndPolicyComponent } from './extensions/privacy-and-policy/privacy-and-policy.component';
import { EventsSignUpComponent } from './extensions/events-sign-up/events-sign-up.component';
import { SocialMediaSignUpComponent } from './extensions/social-media-sign-up/social-media-sign-up.component';
import { WhatsappSignUpComponent } from './extensions/whatsapp-sign-up/whatsapp-sign-up.component';
import { PersonalizedItineraryFormComponent } from './extensions/personalized-itinerary-form/personalized-itinerary-form.component';
import { HomePageTgTourismComponent } from './extensions/home-page-tg-tourism/home-page-tg-tourism.component';
import { TgItineraryFormComponent } from './extensions/tg-itinerary-form/tg-itinerary-form.component';
import { MapviewComponent } from './extensions/mapview/mapview.component';
import { DistrictPlacesInputComponent } from './extensions/district-places-input/district-places-input.component';
import { UserTripDetailsComponent } from './extensions/user-trip-details/user-trip-details.component';
import { UserPreferencesComponent } from './extensions/user-preferences/user-preferences.component';
import { AiRouteCraftComponent } from './extensions/ai-route-craft/ai-route-craft.component';
import { UserHotelsSelectionComponent } from './extensions/user-hotels-selection/user-hotels-selection.component';
import { UserVehiclesSelectionComponent } from './extensions/user-vehicles-selection/user-vehicles-selection.component';
import { UserTripReviewComponent } from './extensions/user-trip-review/user-trip-review.component';



firebase.initializeApp(environment.firebaseConfig);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    AwsRedirectionComponent,
    PrivacyAndPolicyComponent,
    SignUpComponent,
    EventsSignUpComponent,
    SocialMediaSignUpComponent,
    WhatsappSignUpComponent,
    AwsRedirectionFailedComponent,
    HomePageTgTourismComponent,
    TgItineraryFormComponent,
    PersonalizedItineraryFormComponent,
    MapviewComponent,
    DistrictPlacesInputComponent,
    UserTripDetailsComponent,
    UserPreferencesComponent,
    AiRouteCraftComponent,
    UserHotelsSelectionComponent,
    UserVehiclesSelectionComponent,
    UserTripReviewComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    BrowserAnimationsModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandleInterceptorService,
      multi: true
    },
    FirebaseDatabaseService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
